<template>
  <div>
    <div align="right" style="margin: 10px">
      <Button color="primary" @click="add">新增</Button>
    </div>
    <vxe-table border show-overflow size="mini" highlight-hover-row :loading="loading" :data="materialList">
      <vxe-column type="seq" width="60"></vxe-column>
      <vxe-column field="code" title="编码"></vxe-column>
      <vxe-column field="name" title="名称"></vxe-column>
      <vxe-column field="spec" title="规格型号"></vxe-column>
      <vxe-column field="unit" title="计量单位"></vxe-column>
      <vxe-column title="存货科目">
        <template #default="{row}">
          {{ subjectName(row.subjectId) }}
        </template>
      </vxe-column>
      <vxe-column title="操作" width="140">
        <template #default="{row}">
          <span class="actions">
            <span @click="edit(row)">编辑</span>
            <span @click="remove(row)">删除</span>
          </span>
        </template>
      </vxe-column>
    </vxe-table>
    <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
      <div slot="header">物料档案</div>
      <Form ref="form" v-width="420" :labelWidth="100" :model="form" :rules="validationRules">
        <FormItem label="编码" prop="code">
          <input type="text" v-model="form.code">
        </FormItem>
        <FormItem label="名称" prop="name">
          <input type="text" v-model="form.name">
        </FormItem>
        <FormItem label="规格型号" prop="spec">
          <input type="text" v-model="form.spec">
        </FormItem>
        <FormItem label="计量单位" prop="unit">
          <input type="text" v-model="form.unit">
        </FormItem>
        <FormItem label="存货科目" prop="subjectId">
          <Select v-model="form.subjectId" :datas="subjectList" keyName="id" titleName="name"
                  :filterable="true"></Select>
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
        <Button @click="showForm=false" :loading="loading">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2020 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : financial</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2022/6/15 13:43</li>
 * <li>@author     : ____′↘TangSheng</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
const emptyForm = {
  code: '',
  name: '',
  spec: '',
  unit: '',
  subjectId: null
};

export default {
  name: "MaterialArchive",
  data() {
    return {
      materialList: [],
      subjectList: [],
      form: Object.assign({}, emptyForm),
      validationRules: {
        required: ['code', 'name']
      },
      showForm: false,
      loading: false
    }
  },
  methods: {
    loadList() {
      this.loading = true;
      Promise.all([
        this.$api.setting.inventoryMaterial.list(),
        this.$api.setting.subject.voucherSelect({})
      ]).then((results) => {
        this.materialList = results[0].data || [];
        this.subjectList = results[1].data || [];
      }).finally(() => this.loading = false);
    },
    subjectName(subjectId) {
      if (!subjectId) {
        return '-';
      }
      let subject = this.subjectList.find(val => val.id === subjectId);
      return subject ? `${subject.code}-${subject.name}` : '-';
    },
    add() {
      this.form = Object.assign({}, emptyForm);
      this.showForm = true;
    },
    edit(data) {
      this.form = Object.assign({}, data);
      this.showForm = true;
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (validResult.result) {
        this.loading = true;
        this.$api.setting.inventoryMaterial[this.form.id ? 'update' : 'save'](this.form).then(() => {
          this.$Message('保存成功~');
          this.showForm = false;
          this.loadList();
        }).catch(() => {
        }).finally(() => this.loading = false);
      }
    },
    remove(data) {
      this.$Confirm("确认删除?").then(() => {
        this.$api.setting.inventoryMaterial.delete(data.id).then(() => {
          this.loadList();
        })
      })
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>
